// language=GraphQL
export const ALL_ACCOMMODATIONS_QUERY = `query Query($withCapacitySettings: Boolean = false, $withCapacitySettingsAgeGroupCapacities: Boolean = false, $withCapacitySettingsAgeGroupCapacitiesAgeGroup: Boolean = false, $withCapacitySettingsAgeGroupedTotalCapacities: Boolean = false, $withCapacitySettingsAgeGroupedTotalCapacitiesAgeGroups: Boolean = false, $withCapacitySettingsPartialOccupancyAllowedAgeGroups: Boolean = false, $withAddons: Boolean = false, $withAddonsCalculationSettings: Boolean = false, $withAddonsMandatorySettings: Boolean = false, $withAddonsMandatorySettingsRules: Boolean = false, $withAddonsMandatorySettingsDateSwitchSettings: Boolean = false, $withAddonsMandatorySettingsBusSettings: Boolean = false) {
  accommodations: ratioAccommodations {
    id
    ratioPackageNo
    name
    label
    info
    isFamilyPackageAccommodation
    isBabyPackage
    capacitySettings @include(if: $withCapacitySettings) {
      id
      totalCapacity
      rangesAllowed
      ageGroupCapacities @include(if: $withCapacitySettingsAgeGroupCapacities) {
        id
        ageGroup @include(if: $withCapacitySettingsAgeGroupCapacitiesAgeGroup) {
          id
          name
          type
          icon
          minAge
          maxAge
        }
        minCapacity
        maxCapacity
      }
      ageGroupedTotalCapacities @include(if: $withCapacitySettingsAgeGroupedTotalCapacities) {
        id
        ageGroups @include(if: $withCapacitySettingsAgeGroupedTotalCapacitiesAgeGroups) {
          id
          name
          type
          icon
          minAge
          maxAge
        }
        capacity
      }
      partialOccupancyAllowed
      partialOccupancyAllowedAgeGroups @include(if: $withCapacitySettingsPartialOccupancyAllowedAgeGroups) {
        id
        name
        type
        icon
        minAge
        maxAge
      }
    }
    addons @include(if: $withAddons) {
      id
      ratioServiceNo
      name
      label
      info
      calculationSettings @include(if: $withAddonsCalculationSettings) {
        id
        type
        considerHotelNights
      }
      mandatorySettings @include(if: $withAddonsMandatorySettings) {
        id
        isMandatory
        useRules
        rules @include(if: $withAddonsMandatorySettingsRules) {
          id
          checkAccommodationTypes
          checkAccommodationAddons
          checkAgeGroups
          useAgeFilter
          checkDateRange
          startDate
          endDate
          checkTravelDate
        }
        useDateSwitch
        dateSwitchSettings @include(if: $withAddonsMandatorySettingsDateSwitchSettings) {
          id
          startDateOffsetDays
          endDateOffsetDays
        }
        useBusSettings
        busSettings @include(if: $withAddonsMandatorySettingsBusSettings) {
          id
          boardingSelectionEnabled
        }
      }
    }
  }
}`

// language=GraphQL
export const SINGLE_ACCOMMODATION_QUERY = `query Query($id: ID!, $withCapacitySettings: Boolean = false, $withCapacitySettingsAgeGroupCapacities: Boolean = false, $withCapacitySettingsAgeGroupCapacitiesAgeGroup: Boolean = false, $withCapacitySettingsAgeGroupedTotalCapacities: Boolean = false, $withCapacitySettingsAgeGroupedTotalCapacitiesAgeGroups: Boolean = false, $withCapacitySettingsPartialOccupancyAllowedAgeGroups: Boolean = false, $withAddons: Boolean = false, $withAddonsCalculationSettings: Boolean = false, $withAddonsMandatorySettings: Boolean = false, $withAddonsMandatorySettingsRules: Boolean = false, $withAddonsMandatorySettingsDateSwitchSettings: Boolean = false, $withAddonsMandatorySettingsBusSettings: Boolean = false) {
  accommodation: ratioAccommodation(id: $id) {
    id
    ratioPackageNo
    name
    label
    info
    isFamilyPackageAccommodation
    isBabyPackage
    capacitySettings @include(if: $withCapacitySettings) {
      id
      totalCapacity
      rangesAllowed
      ageGroupCapacities @include(if: $withCapacitySettingsAgeGroupCapacities) {
        id
        ageGroup @include(if: $withCapacitySettingsAgeGroupCapacitiesAgeGroup) {
          id
          name
          type
          icon
          minAge
          maxAge
        }
        minCapacity
        maxCapacity
      }
      ageGroupedTotalCapacities @include(if: $withCapacitySettingsAgeGroupedTotalCapacities) {
        id
        ageGroups @include(if: $withCapacitySettingsAgeGroupedTotalCapacitiesAgeGroups) {
          id
          name
          type
          icon
          minAge
          maxAge
        }
        capacity
      }
      partialOccupancyAllowed
      partialOccupancyAllowedAgeGroups @include(if: $withCapacitySettingsPartialOccupancyAllowedAgeGroups) {
        id
        name
        type
        icon
        minAge
        maxAge
      }
    }
    addons @include(if: $withAddons) {
      id
      ratioServiceNo
      name
      label
      info
      calculationSettings @include(if: $withAddonsCalculationSettings) {
        id
        type
        considerHotelNights
      }
      mandatorySettings @include(if: $withAddonsMandatorySettings) {
        id
        isMandatory
        useRules
        rules @include(if: $withAddonsMandatorySettingsRules) {
          id
          checkAccommodationTypes
          checkAccommodationAddons
          checkAgeGroups
          useAgeFilter
          checkDateRange
          startDate
          endDate
          checkTravelDate
        }
        useDateSwitch
        dateSwitchSettings @include(if: $withAddonsMandatorySettingsDateSwitchSettings) {
          id
          startDateOffsetDays
          endDateOffsetDays
        }
        useBusSettings
        busSettings @include(if: $withAddonsMandatorySettingsBusSettings) {
          id
          boardingSelectionEnabled
        }
      }
    }
  }
}`

// language=GraphQL
export const CREATE_ACCOMMODATION_MUTATION = `
  mutation Mutation($input: CreateRatioAccommodationInput, $withCapacitySettings: Boolean = false, $withCapacitySettingsAgeGroupCapacities: Boolean = false, $withCapacitySettingsAgeGroupCapacitiesAgeGroup: Boolean = false, $withCapacitySettingsAgeGroupedTotalCapacities: Boolean = false, $withCapacitySettingsAgeGroupedTotalCapacitiesAgeGroups: Boolean = false, $withCapacitySettingsPartialOccupancyAllowedAgeGroups: Boolean = false, $withAddons: Boolean = false, $withAddonsCalculationSettings: Boolean = false, $withAddonsMandatorySettings: Boolean = false, $withAddonsMandatorySettingsRules: Boolean = false, $withAddonsMandatorySettingsDateSwitchSettings: Boolean = false, $withAddonsMandatorySettingsBusSettings: Boolean = false) {
    accommodation: createRatioAccommodation(input: $input) {
      id
      ratioPackageNo
      name
      label
      info
      isFamilyPackageAccommodation
      isBabyPackage
      capacitySettings @include(if: $withCapacitySettings) {
        id
        totalCapacity
        rangesAllowed
        ageGroupCapacities @include(if: $withCapacitySettingsAgeGroupCapacities) {
          id
          ageGroup @include(if: $withCapacitySettingsAgeGroupCapacitiesAgeGroup) {
            id
            name
            type
            icon
            minAge
            maxAge
          }
          minCapacity
          maxCapacity
        }
        ageGroupedTotalCapacities @include(if: $withCapacitySettingsAgeGroupedTotalCapacities) {
          id
          ageGroups @include(if: $withCapacitySettingsAgeGroupedTotalCapacitiesAgeGroups) {
            id
            name
            type
            icon
            minAge
            maxAge
          }
          capacity
        }
        partialOccupancyAllowed
        partialOccupancyAllowedAgeGroups @include(if: $withCapacitySettingsPartialOccupancyAllowedAgeGroups) {
          id
          name
          type
          icon
          minAge
          maxAge
        }
      }
      addons @include(if: $withAddons) {
        id
        ratioServiceNo
        name
        label
        info
        calculationSettings @include(if: $withAddonsCalculationSettings) {
          id
          type
          considerHotelNights
        }
        mandatorySettings @include(if: $withAddonsMandatorySettings) {
          id
          isMandatory
          useRules
          rules @include(if: $withAddonsMandatorySettingsRules) {
            id
            checkAccommodationTypes
            checkAccommodationAddons
            checkAgeGroups
            useAgeFilter
            checkDateRange
            startDate
            endDate
            checkTravelDate
          }
          useDateSwitch
          dateSwitchSettings @include(if: $withAddonsMandatorySettingsDateSwitchSettings) {
            id
            startDateOffsetDays
            endDateOffsetDays
          }
          useBusSettings
          busSettings @include(if: $withAddonsMandatorySettingsBusSettings) {
            id
            boardingSelectionEnabled
          }
        }
      }
    }
  }`

// language=GraphQL
export const UPDATE_ACCOMMODATION_MUTATION = `
  mutation Mutation($input: UpdateRatioAccommodationInput, $withCapacitySettings: Boolean = false, $withCapacitySettingsAgeGroupCapacities: Boolean = false, $withCapacitySettingsAgeGroupCapacitiesAgeGroup: Boolean = false, $withCapacitySettingsAgeGroupedTotalCapacities: Boolean = false, $withCapacitySettingsAgeGroupedTotalCapacitiesAgeGroups: Boolean = false, $withCapacitySettingsPartialOccupancyAllowedAgeGroups: Boolean = false, $withAddons: Boolean = false, $withAddonsCalculationSettings: Boolean = false, $withAddonsMandatorySettings: Boolean = false, $withAddonsMandatorySettingsRules: Boolean = false, $withAddonsMandatorySettingsDateSwitchSettings: Boolean = false, $withAddonsMandatorySettingsBusSettings: Boolean = false) {
    accommodation: updateRatioAccommodation(input: $input) {
      id
      ratioPackageNo
      name
      label
      info
      isFamilyPackageAccommodation
      isBabyPackage
      capacitySettings @include(if: $withCapacitySettings) {
        id
        totalCapacity
        rangesAllowed
        ageGroupCapacities @include(if: $withCapacitySettingsAgeGroupCapacities) {
          id
          ageGroup @include(if: $withCapacitySettingsAgeGroupCapacitiesAgeGroup) {
            id
            name
            type
            icon
            minAge
            maxAge
          }
          minCapacity
          maxCapacity
        }
        ageGroupedTotalCapacities @include(if: $withCapacitySettingsAgeGroupedTotalCapacities) {
          id
          ageGroups @include(if: $withCapacitySettingsAgeGroupedTotalCapacitiesAgeGroups) {
            id
            name
            type
            icon
            minAge
            maxAge
          }
          capacity
        }
        partialOccupancyAllowed
        partialOccupancyAllowedAgeGroups @include(if: $withCapacitySettingsPartialOccupancyAllowedAgeGroups) {
          id
          name
          type
          icon
          minAge
          maxAge
        }
      }
      addons @include(if: $withAddons) {
        id
        ratioServiceNo
        name
        label
        info
        calculationSettings @include(if: $withAddonsCalculationSettings) {
          id
          type
          considerHotelNights
        }
        mandatorySettings @include(if: $withAddonsMandatorySettings) {
          id
          isMandatory
          useRules
          rules @include(if: $withAddonsMandatorySettingsRules) {
            id
            checkAccommodationTypes
            checkAccommodationAddons
            checkAgeGroups
            useAgeFilter
            checkDateRange
            startDate
            endDate
            checkTravelDate
          }
          useDateSwitch
          dateSwitchSettings @include(if: $withAddonsMandatorySettingsDateSwitchSettings) {
            id
            startDateOffsetDays
            endDateOffsetDays
          }
          useBusSettings
          busSettings @include(if: $withAddonsMandatorySettingsBusSettings) {
            id
            boardingSelectionEnabled
          }
        }
      }
    }
  }`

// language=GraphQL
export const DELETE_ACCOMMODATION_MUTATION = `
  mutation Mutation($input: DeleteRatioAccommodationInput) {
    deleteRatioAccommodation(input: $input) {
      success
    }
  }`

// language=GraphQL
export const FORCE_DELETE_ACCOMMODATION_MUTATION = `
  mutation Mutation($input: DeleteRatioAccommodationInput) {
    forceDeleteRatioAccommodation(input: $input) {
      success
    }
  }`

// language=GraphQL
export const ADD_ACCOMMODATION_ADDONS_MUTATION = `
  mutation Mutation($input: addRatioAccommodationAddonsInput) {
    addRatioAccommodationAddons(input: $input) {
      id
      addonIds
    }
  }`

// language=GraphQL
export const REMOVE_ACCOMMODATION_ADDONS_MUTATION = `
  mutation Mutation($input: removeRatioAccommodationAddonsInput) {
    removeRatioAccommodationAddons(input: $input) {
      id
      addonIds
    }
  }`

// language=GraphQL
export const CREATE_ACCOMMODATION_ADDONS_MUTATION = `
  mutation Mutation($input: createRatioAccommodationAddonsInput) {
    createRatioAccommodationAddons(input: $input) {
      id
      addonIds
    }
  }`

// language=GraphQL
export const DELETE_ACCOMMODATION_ADDONS_MUTATION = `
  mutation Mutation($input: deleteRatioAccommodationAddonsInput) {
    deleteRatioAccommodationAddons(input: $input) {
      id
      addonIds
    }
  }`

// language=GraphQL
export const UPDATE_ACCOMMODATION_ADDONS_ORDER_MUTATION = `
  mutation Mutation($input: updateRatioAccommodationAddonsOrderInput) {
    updateRatioAccommodationAddonsOrder(input: $input) {
      id
      addonIds
    }
  }`

// language=GraphQL
export const ACCOMMODATIONS_DEPENDENTS_QUERY = `query Query($id: ID!, $withRatioAccommodationServices: Boolean = false, $withTravellers: Boolean = false, $withRatioFamilyPackages: Boolean = false, $withRatioAccommodationExtensionMapItems: Boolean = false, $withRatioTravels: Boolean = false, $withTravelPricingRules: Boolean = false) {
  groupedDependents: ratioAccommodationDependents(id: $id) {
    ratioAccommodationServices @include(if: $withRatioAccommodationServices) {
      id
      ratioServiceNo
    }
    travellers @include(if: $withTravellers) {
      id
      salutation
      firstName
      lastName
      birthday
      nationality
      email
      phone
      address
      addressNumber
      addressAddition
      zip
      city
      country
    }
    ratioFamilyPackages @include(if: $withRatioFamilyPackages) {
      id
      ratioServiceNo
      name
      label
      info
    }
    ratioAccommodationExtensionMapItems @include(if: $withRatioAccommodationExtensionMapItems) {
      id
    }
    ratioTravels @include(if: $withRatioTravels) {
      id
      catalogCode
      travelCode
      destination
      name
      transportType
      transportTypeLabel
      importDateTime
      importStatus
      suppressBusBoardingSelection    }
    travelPricingRules @include(if: $withTravelPricingRules) {
      id
      checkAccommodationTypes
      checkAccommodationAddons
      checkAgeGroups
      useAgeFilter
      checkDateRange
      startDate
      endDate
      checkTravelDate
    }
  }
}`
